module.exports = __webpack_public_path__ + "static/images/components/RewardMoney/images/industrial_resources-small.9d3b65d8.png";


//////////////////
// WEBPACK FOOTER
// ./components/RewardMoney/images/industrial_resources-small.png
// module id = 2675
// module chunks = 11